export const UtcInfoContainet = () => (`
  <div style="font-size: 14px;font-weight: 500;text-align: center;color: #000001;">
    All dates and times are expressed in UTC.
  </div>
`);